// EIRAA FASTFIX Steam and Sauna Data

export const companyInfo = {
  name: "FASTFIX",
  brandName: "EIRAA by FASTFIX",
  tagline: "A new rhythm for your wellbeing",
  phone: "+971 50 726 5050",
  email: "info@fastfixdxb.com",
  address: "United Arab Emirates",
  description: "Where exceptional quality meets affordable luxury"
};

export const heroData = {
  title: "FASTFIX",
  subtitle: "EIRAA - A new rhythm for your wellbeing",
  description: "FASTFIX brings you EIRAA, where exceptional quality meets affordable luxury. We specialize in premium, ready-made sauna rooms, offering the perfect blend of relaxation, wellness, and value.",
  ctaPrimary: "Explore Our Saunas",
  ctaSecondary: "Contact Us",
  image: "https://customer-assets.emergentagent.com/job_62116a6f-10ce-41f6-9d09-087f8531a25f/artifacts/8cu9tdho_34ebb6e9-19e0-4692-ae2e-944565d2694b.jpg"
};

export const aboutSections = [
  {
    id: 1,
    title: "About FASTFIX",
    subtitle: "Your Trusted Wellness Partner",
    description: "FASTFIX is a leading manufacturer and installer of premium sauna and steam bath solutions in the UAE. Our EIRAA series embodies harmony, renewal, and the art of intentional living. We are committed to making the luxury of wellness simple, accessible, and stress-free for everyone. Crafted with the finest materials and advanced technology, FASTFIX delivers an unparalleled wellness experience that's both cost-effective and built to last.",
    image: "https://customer-assets.emergentagent.com/job_62116a6f-10ce-41f6-9d09-087f8531a25f/artifacts/f6d8bg6d_38f08aea-044e-4d1d-88dd-7045ce69ed3f.jpg"
  },
  {
    id: 2,
    title: "FASTFIX Excellence",
    subtitle: "Made in UAE - Quality You Can Trust",
    description: "Proudly manufactured in the United Arab Emirates, FASTFIX sauna rooms are designed to deliver comfort, style, and durability. Whether you're transforming your home or enhancing your business, FASTFIX makes it easy to enjoy the benefits of a professional-grade sauna without the hassle. Our EIRAA brand represents the pinnacle of our craftsmanship and innovation.",
    image: "https://customer-assets.emergentagent.com/job_62116a6f-10ce-41f6-9d09-087f8531a25f/artifacts/x2hvj203_173569e0-09d0-413b-9bad-01e4532d509a.jpg"
  }
];

export const productLines = [
  {
    id: 1,
    name: "EIRAA-DOT Spruce",
    tagline: "Economic - Spruce Wood",
    description: "Classic sauna experience with high-quality spruce wood. Perfect for homes and light commercial use with natural warmth and durability.",
    features: [
      "Premium spruce wood construction",
      "Floating bench design",
      "8mm glass door with wooden frame",
      "LED strip lights included",
      "Harvia Vega heater",
      "Clear, Grey, or Bronze glass options"
    ],
    woodOptions: ["Spruce Wood"],
    sizes: [
      { dimension: "150 x 120 x 210cm", capacity: "2 people" },
      { dimension: "200 x 150 x 210cm", capacity: "2-3 people" }
    ],
    image: "https://images.unsplash.com/photo-1757940113920-69e3686438d3",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  },
  {
    id: 2,
    name: "EIRAA-DOT Thermo Spruce",
    tagline: "Economic - Thermo-Treated",
    description: "Enhanced durability with thermo-treated spruce wood. Ideal for high-humidity environments with superior resistance to moisture and decay.",
    features: [
      "Thermo-treated spruce wood",
      "Enhanced moisture resistance",
      "8mm glass door with wooden frame",
      "LED strip lights included",
      "Oceanic OCS-A heater",
      "Long-lasting durability"
    ],
    woodOptions: ["Thermo Spruce Wood"],
    sizes: [
      { dimension: "200 x 150 x 210cm", capacity: "3-4 people" },
      { dimension: "250 x 180 x 210cm", capacity: "5-6 people" }
    ],
    image: "https://images.unsplash.com/photo-1572168400468-62e1b3209d7d",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  },
  {
    id: 3,
    name: "EIRAA-CLEAR Alder",
    tagline: "Premium - Alder Wood",
    description: "Luxurious alder wood with beautiful grain patterns. Premium choice for discerning customers seeking exceptional aesthetics and comfort.",
    features: [
      "Premium alder wood interior",
      "8mm tempered glass front",
      "Floating premium bench",
      "LED strip lights",
      "Oceanic floor-standing heater",
      "Superior natural beauty"
    ],
    woodOptions: ["Alder Wood"],
    sizes: [
      { dimension: "180 x 120 x 210cm", capacity: "2 people" },
      { dimension: "200 x 200 x 210cm", capacity: "3-4 people" }
    ],
    image: "https://images.unsplash.com/photo-1757937176646-d943553b5f09",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  },
  {
    id: 4,
    name: "EIRAA-CLEAR Aspen",
    tagline: "Premium - Aspen Wood",
    description: "Elegant aspen wood known for its light color and smooth texture. Perfect for modern spa environments and luxury homes.",
    features: [
      "Premium aspen wood interior",
      "Light, elegant appearance",
      "8mm tempered glass design",
      "LED strip lights",
      "Harvia Wall heater",
      "Low heat retention (stays cool)"
    ],
    woodOptions: ["Aspen Wood"],
    sizes: [
      { dimension: "180 x 150 x 210cm", capacity: "2-3 people" },
      { dimension: "200 x 200 x 210cm", capacity: "4-5 people" }
    ],
    image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  },
  {
    id: 5,
    name: "EIRAA-CLEAR Thermo-Aspen",
    tagline: "Premium - Thermo-Aspen",
    description: "The ultimate premium option with thermo-treated aspen. Combines elegance with enhanced durability for the most demanding applications.",
    features: [
      "Thermo-treated aspen wood",
      "Enhanced stability & durability",
      "8mm fully enclosed glass",
      "Premium LED lighting",
      "Oceanic OXS touch control heater",
      "Rich, dark appearance"
    ],
    woodOptions: ["Thermo-Aspen Wood"],
    sizes: [
      { dimension: "200 x 200 x 210cm", capacity: "3-4 people" },
      { dimension: "250 x 150 x 210cm", capacity: "5-6 people" }
    ],
    image: "https://images.unsplash.com/photo-1554424518-336ec861b705",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  },
  {
    id: 6,
    name: "EIRAA Custom Series",
    tagline: "Bespoke Solutions",
    description: "Fully customizable sauna designed to your exact specifications. Choose dimensions, wood type, glass options, and features for your perfect wellness sanctuary.",
    features: [
      "Custom dimensions available",
      "Choice of all wood types",
      "Personalized glass & door design",
      "Premium heater selection",
      "Custom LED & lighting options",
      "Tailored to your space"
    ],
    woodOptions: ["All Wood Types Available"],
    sizes: [
      { dimension: "Custom", capacity: "Custom" }
    ],
    image: "https://images.unsplash.com/photo-1757940661240-f2e8d2ff93bf",
    accessories: ["Wooden bucket", "Wooden ladle", "Sand timer", "Hygro-thermo meter", "Sauna rocks"]
  }
];

export const heaters = [
  {
    id: 1,
    name: "Harvia Vega",
    description: "A modern and easy-to-use heater with stainless steel outer shell. Operating switches are ergonomically placed in the upper part. Can be mounted low on the sauna wall for optimal steam distribution.",
    features: ["Stainless steel construction", "Ergonomic controls", "Modern design", "Xenio control panel"],
    sizes: "Available in multiple sizes based on room dimensions"
  },
  {
    id: 2,
    name: "Oceanic OCS-A Series",
    description: "Wall-hung sauna heaters from 3kw to 9kw, suitable for home or light commercial applications. CE safety tested in UK by Nemko and RoHS tested in Germany by Hermes.",
    features: ["3kw to 9kw range", "CE certified", "RoHS compliant", "Multiple control panel options"],
    controlPanels: ["OCSB control panel", "OCA control panel", "OXS Touch screen control panel"]
  },
  {
    id: 3,
    name: "Oceanic Floor Standing",
    description: "Brand new Oceanic saunas heaters combining elegant aesthetics with innovative functionality. Dark grey powder coated shell with stainless steel capping. Vented rock basket protects elements.",
    features: ["Floor standing design", "Elegant dark grey finish", "Protected heating elements", "Reduced maintenance"]
  }
];

export const features = [
  {
    id: 1,
    title: "Ready-Made Solution",
    description: "Pre-assembled sauna rooms ready for installation. No complex assembly required—just pure relaxation, made easy.",
    icon: "Package"
  },
  {
    id: 2,
    title: "Premium Materials",
    description: "Crafted with the finest spruce, alder, aspen, and thermo-treated woods for durability and natural beauty.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Advanced Technology",
    description: "Equipped with premium Harvia and Oceanic heaters, LED lighting, and modern control systems.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Made in UAE",
    description: "Proudly manufactured in the United Arab Emirates with international quality standards.",
    icon: "Award"
  },
  {
    id: 5,
    title: "Versatile Sizing",
    description: "Multiple configurations available from intimate 2-person saunas to spacious 6-person wellness spaces.",
    icon: "Maximize"
  },
  {
    id: 6,
    title: "Complete Package",
    description: "Includes all accessories: wooden bucket, ladle, timer, thermometer, and sauna rocks.",
    icon: "CheckCircle"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Stress Relief",
    description: "Experience deep relaxation and mental clarity through regular sauna sessions in your personal wellness sanctuary.",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "Detoxification",
    description: "Eliminate toxins and impurities through natural perspiration in the comforting warmth of premium wood.",
    icon: "Droplets"
  },
  {
    id: 3,
    title: "Muscle Recovery",
    description: "Accelerate recovery and reduce muscle soreness with consistent heat therapy after workouts.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Better Circulation",
    description: "Improve blood flow and cardiovascular health with regular sauna use in a tranquil environment.",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Quality Sleep",
    description: "Promote deeper, more restful sleep through evening sauna sessions that calm mind and body.",
    icon: "Moon"
  },
  {
    id: 6,
    title: "Immunity Boost",
    description: "Strengthen your immune system with regular heat therapy in your own wellness space.",
    icon: "Shield"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmed Al Mansouri",
    role: "Homeowner, Dubai",
    content: "EIRAA transformed our home wellness experience. The quality of the spruce wood and the easy installation process exceeded our expectations. It's like having a luxury spa at home.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Johnson",
    role: "Wellness Center Owner",
    content: "We installed three EIRAA-CLEAR saunas in our facility. Our clients love the premium feel and the variety of wood options. The made-in-UAE quality is outstanding.",
    rating: 5
  },
  {
    id: 3,
    name: "Mohammed Hassan",
    role: "Villa Owner, Abu Dhabi",
    content: "The EIRAA-DOT is perfect for our family. Excellent value for money, beautiful design, and the customer service was exceptional. Highly recommended!",
    rating: 5
  }
];